import { Heading } from "@/components/base/heading";
import { SummaryItem } from "@/components/bli-medlem/summary/summary-item";
import { HorizontalContainer } from "@/components/layout/horizontal-container";
import { HorizontalSpacer } from "@/components/layout/horizontal-spacer";
import { PageContent } from "@/components/layout/page-content";
import { VerticalContainer } from "@/components/layout/vertical-container";
import { ButtonSkeleton } from "@/components/skeletons/button-skeleton";
import { TextSkeleton } from "@/components/skeletons/text-skeleton";

export function SummarySkeleton() {
  return (
    <PageContent width="x-small">
      <VerticalContainer horizontalPlacement="left" width="full">
        <HorizontalContainer horizontalPlacement="center" width="full">
          <Heading type="h2">Du har valgt</Heading>
        </HorizontalContainer>
        <HorizontalSpacer />

        <hr />
        <HorizontalSpacer />

        <SummaryItem heading="Aldersgruppe:" horizontalPlacement="space" showRuler={true}>
          <TextSkeleton size={"small"} />
        </SummaryItem>

        <SummaryItem heading="Primærsenter:" horizontalPlacement="space" showRuler={true}>
          <TextSkeleton size={"small"} />
        </SummaryItem>

        <SummaryItem heading="Medlemskap:" horizontalPlacement="space" showRuler={true}>
          <TextSkeleton size={"small"} />
        </SummaryItem>

        <HorizontalSpacer size="medium" />

        <HorizontalContainer horizontalPlacement="center" verticalPlacement="top" width="full">
          <Heading type="h2">Til betaling i dag</Heading>
        </HorizontalContainer>
        <HorizontalSpacer />

        <HorizontalSpacer />
      </VerticalContainer>

      <HorizontalContainer horizontalPlacement="center">
        <ButtonSkeleton />
      </HorizontalContainer>
      <HorizontalSpacer size="large" />
    </PageContent>
  );
}
